export default __webpack_public_path__ + "static/media/Caja_larga_Focus.2cbca17a.svg";